export interface WizardState {
  narrativeInput: string;
  suggestionPage: number;
  confirmingAccept: boolean;
}

export const initialWizardState: WizardState = {
  narrativeInput: '',
  suggestionPage: 0,
  confirmingAccept: false,
};

export type WizardAction =
  | { type: 'SET_INPUT'; value: string }
  | { type: 'SET_PAGE'; value: number }
  | { type: 'START_CONFIRM' }
  | { type: 'CANCEL_CONFIRM' };

export const wizardReducer = (state: WizardState, action: WizardAction): WizardState => {
  switch (action.type) {
    case 'SET_INPUT':
      return { ...state, narrativeInput: action.value };
    case 'SET_PAGE':
      return { ...state, suggestionPage: Math.max(0, action.value) };
    case 'START_CONFIRM':
      return { ...state, confirmingAccept: true };
    case 'CANCEL_CONFIRM':
      return { ...state, confirmingAccept: false };
    default:
      return state;
  }
};
